import React, { Fragment, Component } from 'react'
import i18n from 'i18next'

import ModalHeader from '../../../UniformComponents/ModalHeader'
import ModalFooter from '../../../UniformComponents/ModalFooter'
import Button from '../../../UniformComponents/Button'
import Panel from '../../../UniformComponents/Panel'

class Raw extends Component {
    downloadOptions = [
        {
            name: '3s',
            label: i18n.t('download.modal.triple_s'),
        },
        {
            name: 'csv',
            label: i18n.t('s_csv'),
        },
    ]

    constructor(props) {
        super(props)

        this.state = {
            selected: null,
        }
    }

    render() {
        const { onClose, store } = this.props
        const { selected } = this.state

        return (
            <Fragment>
                <div className="uc-modal__header">
                    <h2>{i18n.t('download.modal.raw')}</h2>
                    <p className="uc-modal__desc">{i18n.t('download.modal.gen.subtitle')}</p>
                </div>
                <div className="body">
                    {this.downloadOptions.map((option) => (
                        <Panel
                            cssClass={`${selected === option.name ? 'active' : ''}`}
                            onClick={() => this.setState({ selected: option.name })}
                        >
                            <h5>{option.label}</h5>
                            <div style={{ marginTop: '25px', textAlign: 'center' }}>
                                <i className="far fa-check" />
                            </div>
                        </Panel>
                    ))}
                </div>
                <div className="uc-modal__button-panel">
                    <Button
                        label={i18n.t('cancel')}
                        cssClass="tertiary"
                        onClick={onClose}
                    />
                    <Button
                        label={i18n.t('download')}
                        cssClass="primary"
                        onClick={() => store.setDownloadType(selected)}
                    />
                </div>
            </Fragment>
        )
    }
}

export default Raw
